<!--Update Environment Title-->
<h2>Update Environment</h2>
<p>Environment Id: {{selectedEnvironment.environmentId}}</p>
<p>Name: {{selectedEnvironment.name}}</p>
<p>Description: {{selectedEnvironment.description}}</p>
<p>Version: {{selectedEnvironment.version}}</p>
<p>Is Production: {{selectedEnvironment.isProduction}}</p>
<p>Status: {{selectedEnvironment.statusMessage}}</p>
<mat-dialog-content>
    <!--Dialog Content-->
    <div *ngIf="!updateCloudEnvironmentResponse">
        <form novalidate>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Maintenance</mat-label>
                    <mat-select [(ngModel)]="updateCloudEnvironmentRequest.inMaintenanceMode"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let item of booleanCollection" [value]="item">
                            <span>{{item}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Available</mat-label>
                    <mat-select [(ngModel)]="updateCloudEnvironmentRequest.isAvailable"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let item of booleanCollection" [value]="item">
                            {{item}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Enabled</mat-label>
                    <mat-select [(ngModel)]="updateCloudEnvironmentRequest.isEnabled"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let item of booleanCollection" [value]="item">
                            {{item}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div *ngIf="updateCloudEnvironmentResponse">
        <span class="success">
            <mat-icon>check_circle</mat-icon> updated successfully
        </span>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <!--Dialog action buttons-->
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving"
        *ngIf="!updateCloudEnvironmentResponse">
        <span *ngIf="!isSaving">Save</span>
        <span *ngIf="isSaving">Saving...</span>
    </button>
    <button mat-raised-button [disabled]="isSaving" (click)="close()">Cancel</button>
</mat-dialog-actions>